import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import './DriverLoadNotes.scss';
import moment from 'moment';
import { PermissionEnum } from '../../../../types/PermissionEnum';
import { useAuthContext } from '../../../Auth/AuthProvider';
import { formatDateUtcToLocal } from '../../../../utils/helpers/datetimeHelper';

interface ToolTipProps {
    data?: any;
    onEditNote: (id: number, note: string) => void;
    onDeleteNote: (id: number) => void;
    onResolveNote: (id: number) => void;
    onResolveAllNotes: (id: number) => void;
}

const DriverLoadNotes = ({
    onEditNote,
    onDeleteNote,
    onResolveNote,
    onResolveAllNotes,
    data,
}: ToolTipProps): React.ReactElement => {
    const authContext = useAuthContext();
    const isEditDriverLoadNotesEnabled = authContext.userHasPermission(PermissionEnum.EditDriverLoadNotes);
    const isDeleteDriverLoadNotesEnabled = authContext.userHasPermission(PermissionEnum.DeleteDriverLoadNotes);
    const onEditClick = e => {
        
        document.body.click();
        onEditNote(e.id, e.notes);
    };

    const onDeleteClick = e => {
        
        document.body.click();
        onDeleteNote(e.id);
    };

    const onResolveClick = e => {
        
        document.body.click();
        onResolveNote(e.id);
    };

    const onResolveAllClick = e => {
        
        document.body.click();
        onResolveAllNotes(e.loadId);
    };

    const popoverRight = t => {
        if (t) {
            return (
                <Popover id="popover-positioned-scrolling-right" title="Popover right">
                    <div
                        style={{
                            padding: '10px',
                            width: '290px',
                            maxHeight: '515px',
                            overflowY: 'scroll',
                            paddingRight: '0px',
                        }}
                    >
                        <div
                            style={{
                                borderBottom: '1px solid lightgray',
                                marginBottom: '10px',
                                padding: '10px',
                                paddingBottom: '0px',
                                marginRight: '10px',
                            }}
                        >
                            <div style={{ float: 'right', marginRight: '-10px' }}>
                                <span className="JobActivityItem-Name" onClick={() => onResolveAllClick(t.notes[0])}>
                                    Resolve All
                                </span>
                            </div>
                            <div
                                style={{
                                    marginBottom: '20px',
                                }}
                            ></div>
                            <div></div>
                        </div>

                        {t.notes.map(function(object, i) {
                            return (
                                <div key={object.loadId}>
                                    <div>
                                        <div style={{ float: 'right', marginRight: '10px' }}>
                                            <span>
                                                {isEditDriverLoadNotesEnabled && (
                                                    <i
                                                        title="Resolve"
                                                        className="material-icons Info-Icon"
                                                        onClick={() => onResolveClick(object)}
                                                    >
                                                        check
                                                    </i>
                                                )}
                                                {isEditDriverLoadNotesEnabled && (
                                                    <i
                                                        title="Edit"
                                                        className="material-icons Info-Icon"
                                                        onClick={() => onEditClick(object)}
                                                    >
                                                        edit
                                                    </i>
                                                )}
                                                {isDeleteDriverLoadNotesEnabled && (
                                                    <i
                                                        title="Delete"
                                                        className="material-icons Info-Icon"
                                                        onClick={() => onDeleteClick(object)}
                                                    >
                                                        delete
                                                    </i>
                                                )}
                                            </span>
                                        </div>
                                        <div>
                                            <span style={{ fontSize: '16px', fontWeight: 'bolder' }}>
                                                {object.name}
                                            </span>
                                        </div>
                                        <div>
                                            <span style={{ fontSize: '12px' }}>
                                                {formatDateUtcToLocal(object.createDate)}
                                            </span>
                                        </div>
                                    </div>
                                    <div style={{ marginTop: '10px', width: '260px' }}>
                                        <p>{object.notes}</p>
                                    </div>
                                    {t.notes.length > i + 1 && (
                                        <div
                                            style={{
                                                borderBottom: '1px solid lightgray',
                                                marginBottom: '10px',
                                                marginRight: '20px',
                                            }}
                                        ></div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </Popover>
            );
        } else {
            return <div></div>;
        }
    };

    return (
        <OverlayTrigger trigger="click" placement="right" overlay={popoverRight(data)} rootClose={true}>
            <i
                style={{ marginLeft: '15px', fontSize: '18px' }}
                className="material-icons Info-Icon"
                onClick={() => document.body.click()}
            >
                info
            </i>
        </OverlayTrigger>
    );
};
DriverLoadNotes.displayName = 'DriverLoadNotes';
export default DriverLoadNotes;

